export { default as NotFoundPage } from './NotFound/NotFoundPage';
export { default as GenericErrorPage } from './GenericError/GenericErrorPage';



// WEBPACK FOOTER //
// ./src/pages/ErrorPages/index.js